import { render, staticRenderFns } from "./verzenden.vue?vue&type=template&id=08ea1fd9&scoped=true"
import script from "./verzenden.vue?vue&type=script&lang=js"
export * from "./verzenden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea1fd9",
  null
  
)

export default component.exports